import * as React from 'react'
import { BaseFormFieldProps } from '../BaseProps'
import { FieldFooter } from '../FieldFooter'
import { FormFieldLabel } from './FormFieldLabel'
import { FormFieldWrapper } from './FormFieldWrapper'
import { TextInput } from '../Inputs'

export const TextFormField = (props: BaseFormFieldProps) => (
    <FormFieldWrapper {...props}>
        {props.label && <FormFieldLabel {...props} />}
        <TextInput {...props} />
        <FieldFooter error={props.error} errorDescription={props.errorDescription} />
    </FormFieldWrapper>
)
